import React from "react";

const MASKS = {
  red: "/brand/mask-red.webp",
  navy: "/brand/mask-navy.webp",
  white: "/brand/mask-white.png",
};

// Authentic Koreyaah 'tal' mask logomark (brand asset)
export const MaskLogo = ({ className = "", variant = "red", alt = "Koreyaah mask" }) => (
  <img src={MASKS[variant] || MASKS.red} alt={alt} className={className} loading="eager" draggable="false" />
);

export const Wordmark = ({ className = "", variant = "red" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <MaskLogo className="h-12 w-auto" variant={variant} />
    <span className="font-display text-3xl tracking-tight text-koreyaah-indigo leading-none">
      Koreyaah
    </span>
  </div>
);

// Decorative cloud blob motif
export const CloudBlob = ({ className = "", color = "#EF1C25" }) => (
  <svg viewBox="0 0 200 120" className={className} fill={color} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M40 90c-20 0-30-14-26-30 3-13 16-20 28-16 3-18 20-30 40-26 15 3 24 15 24 28 16-4 30 6 32 22 2 16-10 28-26 28H40Z" />
  </svg>
);

// Brand social icons (lucide removed these) — inline SVG
export const InstagramIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

export const FacebookIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

export const LinkedinIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);
